import React from "react";
import LeadingText from "../LeadingText";
import SupportingText from "../SupportingText";
import { formatPrice } from "../helpers";

export default function ArticleCardHeader({
  articleID,
  brand,
  isLoggedIn,
  showPrice,
  showUVP,
  uvp,
  price
}) {
  return (
    <div className="w-full flex items-center justify-center pb-2 border-grey-lighter border-b">
      <div className="w-2/3 border-red-light border-l-4 pl-3">
        <div className="flex flex-col items-start">
          <LeadingText textSize="base" fontWeight="normal">
            {articleID}
          </LeadingText>
          <div className="mt-1 ">
            <SupportingText fontWeight="thin">{brand}</SupportingText>
          </div>
        </div>
      </div>
      <div className="w-1/3">
        <SupportingText textSize="sm" textAlign="right" textColor="red-light">
          {isLoggedIn && showPrice && price ? `${formatPrice(price)} €` : null}
        </SupportingText>
        <SupportingText textSize="sm" textAlign="right" textColor="black">
          {showUVP && uvp ? `UVP ${formatPrice(uvp)} €` : null}
        </SupportingText>
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/ArticleCardHeader/ArticleCardHeader.js